import Dispatcher from '../Dispatcher';

const checkDisabled = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'development':
      return false;
    default:
      return true;
  }
};

const enablementFilter = {
  isDisabled: checkDisabled(),
};

Dispatcher.registerInit(enablementFilter, () => {
  // eslint-disable-next-line no-console
  console.log('#analytics - init');
});

Dispatcher.registerIdentify(enablementFilter, ({ userId, properties }) => {
  // eslint-disable-next-line no-console
  console.log(`#analytics - identify userId:${userId} properties:${JSON.stringify(properties, 2, 2)}`);
});

Dispatcher.registerLogEvent(enablementFilter, ({ eventName, eventProperties }) => {
  // eslint-disable-next-line no-console
  console.log(`#analytics - logEvent name:${eventName} properties:${JSON.stringify(eventProperties, 2, 2)}`);
});

Dispatcher.registerLogPage(enablementFilter, ({ eventName, eventProperties }) => {
  // eslint-disable-next-line no-console
  console.log(`#analytics - logPage name:${eventName} properties:${JSON.stringify(eventProperties, 2, 2)}`);
});
